import { render, staticRenderFns } from "./BillingPagination.vue?vue&type=template&id=4157b4aa&"
import script from "./BillingPagination.vue?vue&type=script&lang=js&"
export * from "./BillingPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4157b4aa')) {
      api.createRecord('4157b4aa', component.options)
    } else {
      api.reload('4157b4aa', component.options)
    }
    module.hot.accept("./BillingPagination.vue?vue&type=template&id=4157b4aa&", function () {
      api.rerender('4157b4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/billing/components/BillingPagination.vue"
export default component.exports